const _excluded = ["onChange", "onFocus", "onBlur", "value", "error", "size", "counter", "maxLength", "components", "disablePaste", "onPaste", "className", "placeholder", "dataTestId", "readOnly"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import clsx from 'clsx';
import { FormSize } from "../../../view-model";
import TextareaAutosize from 'react-textarea-autosize';
import { useFormCommonProps } from "../../context/form-common";
import { components as defaultComponents } from "./components";
import '@isyc-react/design/main';
export const InputTextarea = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _value$length;
  const _useFormCommonProps = useFormCommonProps(props),
    {
      onChange,
      onFocus,
      onBlur,
      value,
      error,
      size,
      counter = true,
      maxLength,
      components = defaultComponents,
      disablePaste = false,
      onPaste,
      className = 'form-control',
      placeholder,
      dataTestId,
      readOnly
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded);
  const {
    Container = defaultComponents.Container,
    CounterContainer = defaultComponents.CounterContainer,
    Counter = defaultComponents.Counter
  } = components;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(TextareaAutosize, _extends({}, rest, {
    ref: ref,
    "data-test-id": dataTestId,
    className: clsx({
      'form-control-sm': size === FormSize.SM,
      'form-control-lg': size === FormSize.LG,
      'form-control-xl': size === FormSize.XL,
      'is-invalid': error,
      'form-control-plaintext': readOnly,
      [className]: !readOnly
    }),
    onPaste: e => {
      if (disablePaste) {
        e.preventDefault();
        return false;
      } else if (onPaste) onPaste(e);
    },
    onChange: e => {
      onChange && onChange(e.target.value, e);
    },
    onFocus: () => onFocus && onFocus(),
    onBlur: () => onBlur && onBlur(),
    value: value,
    maxLength: maxLength,
    placeholder: placeholder
  })), /*#__PURE__*/React.createElement(CounterContainer, {
    show: Boolean(maxLength) || counter
  }, /*#__PURE__*/React.createElement(Counter, {
    limit: maxLength,
    counter: counter,
    count: (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0
  }))));
});